export default __webpack_public_path__ + "static/media/Go4-logo-V2.678dde93.svg";